import { SolutionType } from '@dc-shared-web/hooks/api/solutionType'
import { CubeSolutionType, mapCubeToSolutionType } from '@dc-shared-web/lib'
import { AxiosInstance } from 'axios'

export type GetSolutionTypeQueryParams = {
  team: string
}

export const fetchSolutionTypes = async (
  apiClient: AxiosInstance,
  params?: GetSolutionTypeQueryParams
): Promise<SolutionType[]> => {
  const {
    data: { data },
  } = await apiClient.get(`/ajax/cube/crunchTypes`, {
    params: { currentTeam: params?.team },
  })
  return data.map((item: CubeSolutionType) => mapCubeToSolutionType(item))
}
